module.exports = __webpack_public_path__ + "assets/img/1587371168668.5e100238.jpg";